import { SupportedLocale } from '../constants/locale'

export const normalizeSupportedLocale = (
  input?: string | null
): SupportedLocale => {
  const normalized = input?.trim().toLowerCase()
  if (!normalized) return SupportedLocale.EN

  if (normalized.startsWith('es')) return SupportedLocale.ES_MX
  if (normalized.startsWith('en')) return SupportedLocale.EN

  return SupportedLocale.EN
}
